// Comprehensive country codes for international phone authentication
export const countryCodes = [
  // Major countries
  { value: '+1', label: '+1 (United States)', country: 'US' },
  { value: '+1', label: '+1 (Canada)', country: 'CA' },
  { value: '+44', label: '+44 (United Kingdom)', country: 'GB' },
  { value: '+33', label: '+33 (France)', country: 'FR' },
  { value: '+49', label: '+49 (Germany)', country: 'DE' },
  { value: '+39', label: '+39 (Italy)', country: 'IT' },
  { value: '+34', label: '+34 (Spain)', country: 'ES' },
  { value: '+7', label: '+7 (Russia)', country: 'RU' },
  { value: '+86', label: '+86 (China)', country: 'CN' },
  { value: '+81', label: '+81 (Japan)', country: 'JP' },
  { value: '+82', label: '+82 (South Korea)', country: 'KR' },
  { value: '+91', label: '+91 (India)', country: 'IN' },

  // Middle East
  { value: '+971', label: '+971 (UAE)', country: 'AE' },
  { value: '+966', label: '+966 (Saudi Arabia)', country: 'SA' },
  { value: '+974', label: '+974 (Qatar)', country: 'QA' },
  { value: '+965', label: '+965 (Kuwait)', country: 'KW' },
  { value: '+968', label: '+968 (Oman)', country: 'OM' },
  { value: '+973', label: '+973 (Bahrain)', country: 'BH' },
  { value: '+962', label: '+962 (Jordan)', country: 'JO' },
  { value: '+961', label: '+961 (Lebanon)', country: 'LB' },
  { value: '+20', label: '+20 (Egypt)', country: 'EG' },

  // South Asia
  { value: '+92', label: '+92 (Pakistan)', country: 'PK' },
  { value: '+880', label: '+880 (Bangladesh)', country: 'BD' },
  { value: '+94', label: '+94 (Sri Lanka)', country: 'LK' },
  { value: '+977', label: '+977 (Nepal)', country: 'NP' },

  // Southeast Asia
  { value: '+60', label: '+60 (Malaysia)', country: 'MY' },
  { value: '+65', label: '+65 (Singapore)', country: 'SG' },
  { value: '+66', label: '+66 (Thailand)', country: 'TH' },
  { value: '+62', label: '+62 (Indonesia)', country: 'ID' },
  { value: '+63', label: '+63 (Philippines)', country: 'PH' },
  { value: '+84', label: '+84 (Vietnam)', country: 'VN' },

  // Australia & New Zealand
  { value: '+61', label: '+61 (Australia)', country: 'AU' },
  { value: '+64', label: '+64 (New Zealand)', country: 'NZ' },

  // Africa
  { value: '+27', label: '+27 (South Africa)', country: 'ZA' },
  { value: '+234', label: '+234 (Nigeria)', country: 'NG' },
  { value: '+254', label: '+254 (Kenya)', country: 'KE' },
  { value: '+233', label: '+233 (Ghana)', country: 'GH' },
  { value: '+251', label: '+251 (Ethiopia)', country: 'ET' },

  // Europe
  { value: '+31', label: '+31 (Netherlands)', country: 'NL' },
  { value: '+32', label: '+32 (Belgium)', country: 'BE' },
  { value: '+41', label: '+41 (Switzerland)', country: 'CH' },
  { value: '+43', label: '+43 (Austria)', country: 'AT' },
  { value: '+45', label: '+45 (Denmark)', country: 'DK' },
  { value: '+46', label: '+46 (Sweden)', country: 'SE' },
  { value: '+47', label: '+47 (Norway)', country: 'NO' },
  { value: '+48', label: '+48 (Poland)', country: 'PL' },
  { value: '+351', label: '+351 (Portugal)', country: 'PT' },
  { value: '+30', label: '+30 (Greece)', country: 'GR' },
  { value: '+90', label: '+90 (Turkey)', country: 'TR' },

  // South America
  { value: '+55', label: '+55 (Brazil)', country: 'BR' },
  { value: '+54', label: '+54 (Argentina)', country: 'AR' },
  { value: '+56', label: '+56 (Chile)', country: 'CL' },
  { value: '+57', label: '+57 (Colombia)', country: 'CO' },
  { value: '+51', label: '+51 (Peru)', country: 'PE' },
  { value: '+58', label: '+58 (Venezuela)', country: 'VE' },

  // Others
  { value: '+52', label: '+52 (Mexico)', country: 'MX' },
  { value: '+972', label: '+972 (Israel)', country: 'IL' },
  { value: '+98', label: '+98 (Iran)', country: 'IR' },
  { value: '+852', label: '+852 (Hong Kong)', country: 'HK' },
  { value: '+886', label: '+886 (Taiwan)', country: 'TW' },
];

// Function to get default country code (no default - user must select)
export const getDefaultCountryCode = () => {
  // Check if user has a previously used country code in localStorage
  const saved = localStorage.getItem('preferredCountryCode');
  if (saved && countryCodes.find(c => c.value === saved)) {
    return saved;
  }

  // No default - return null to force user selection
  return null;
};

// Function to save user's country code preference
export const saveCountryCodePreference = (countryCode) => {
  localStorage.setItem('preferredCountryCode', countryCode);
};

// Function to format phone number with country code
export const formatPhoneWithCountry = (phoneNumber, countryCode) => {
  if (!phoneNumber || !countryCode) return '';

  // Remove any leading + or country code from phone number
  const cleanPhone = phoneNumber.replace(/^\+?\d{1,4}/, '').trim();

  return `${countryCode}${cleanPhone}`;
};

// Function to validate phone number format for different countries
export const validatePhoneNumber = (phoneNumber, countryCode) => {
  if (!phoneNumber || !countryCode) return false;

  // Remove spaces, dashes, and parentheses
  const cleanPhone = phoneNumber.replace(/[\s\-()]/g, '');

  // Basic validation patterns for different countries
  const patterns = {
    '+1': /^\d{10}$/, // US/Canada
    '+44': /^\d{10,11}$/, // UK
    '+91': /^\d{10}$/, // India
    '+971': /^\d{8,9}$/, // UAE
    '+86': /^\d{11}$/, // China
    '+81': /^\d{10,11}$/, // Japan
    '+33': /^\d{9,10}$/, // France
    '+49': /^\d{10,12}$/, // Germany
    '+39': /^\d{9,11}$/, // Italy
    '+34': /^\d{9}$/, // Spain
    '+7': /^\d{10}$/, // Russia
    '+82': /^\d{8,9}$/, // South Korea
    '+966': /^\d{8,9}$/, // Saudi Arabia
    '+974': /^\d{8}$/, // Qatar
    '+965': /^\d{8}$/, // Kuwait
    '+61': /^\d{9}$/, // Australia
    '+64': /^\d{8,9}$/, // New Zealand
    // Add more patterns as needed
  };

  const pattern = patterns[countryCode] || /^\d{7,15}$/; // Generic fallback
  return pattern.test(cleanPhone);
};

export default countryCodes;